exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".guify-select-dropdown {\n  display: inline-block;\n  position: absolute;\n  width: 62%;\n  padding-left: 1.5%;\n  height: 20px;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  appearance: none;\n  font-family: inherit;\n  background-color: #363636;\n  color: #a1a1a1;\n  box-sizing: border-box !important;\n  -moz-box-sizing: border-box !important;\n  -webkit-box-sizing: border-box !important; }\n\n.guify-select-dropdown::-ms-expand {\n  display: none; }\n\n.guify-select-triangle {\n  content: ' ';\n  border-right: 3px solid transparent;\n  border-left: 3px solid transparent;\n  line-height: 20px;\n  position: absolute;\n  right: 2.5%;\n  z-index: 1; }\n\n.guify-select-triangle--down {\n  top: 11px;\n  border-top: 5px solid #a1a1a1;\n  border-bottom: 0px transparent; }\n\n.guify-select-triangle--up {\n  top: 4px;\n  border-bottom: 5px solid #a1a1a1;\n  border-top: 0px transparent; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/components/select.scss
// module id = 43
// module chunks = 0